export default class RegExps {

    static uuid = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}';
    static time = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
    static timeRange = `${RegExps.time}-${RegExps.time}`;

}
